import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { ReportDto } from "../types/report";

export default function serviceLocationReportReducer(
  state: ReportDto = initialState.serviceLocationReport,
  action: AnyAction
): ReportDto {
  switch (action.type) {
    case internalActionKeys.GET_SERVICE_LOC_REPORT_SUCCESS:
      return action.report;
    default:
      return state;
  }
}
